<script lang="ts">
    type LogoSize = "xs" | "sm" | "md" | "lg" | "xl" | "huge";

    interface Props {
        size?: LogoSize;
    }

    let { size = "sm" }: Props = $props();
    let sizeVar = $derived(`var(--avatar-${size})`);
    const uid = Math.random().toString(36).slice(2, 8);
</script>

<div class="logo" style={`width: ${sizeVar}; height: ${sizeVar}`}>
    <svg viewBox="0 0 32 32">
        <defs>
            <linearGradient
                id={`logo_gradient_one_${uid}`}
                x1="16.0078"
                y1="0"
                x2="16.0078"
                y2="31.9999"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FBB03B" />
                <stop offset="1" stop-color="#F05A24" />
            </linearGradient>
            <linearGradient
                id={`logo_gradient_two_${uid}`}
                x1="16.0078"
                y1="0"
                x2="16.0078"
                y2="31.9999"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#ED1E79" />
                <stop offset="1" stop-color="#5F2583" />
            </linearGradient>
        </defs>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0078 0C24.8443 0 32.0078 7.16342 32.0078 16C32.0078 24.8365 24.8443 31.9999 16.0078 31.9999C7.17124 31.9999 0.0078125 24.8365 0.0078125 16C0.0078229 7.16343 7.17125 2.16966e-05 16.0078 0ZM16.0078 7.11106C11.0986 7.11106 7.11888 11.0908 7.11887 16C7.11887 20.9091 11.0986 24.8888 16.0078 24.8888C20.917 24.8888 24.8967 20.9091 24.8967 16C24.8966 11.0908 20.9169 7.11106 16.0078 7.11106Z"
            fill={`url(#logo_gradient_one_${uid})`} />
        <path
            d="M25.2343 2.92687C29.3321 5.82424 32.0078 10.5996 32.0078 16C32.0078 21.4009 29.3316 26.1766 25.2331 29.0739L21.0728 23.3054C23.3837 21.7002 24.8967 19.0268 24.8967 16C24.8967 12.9558 23.3664 10.2692 21.0332 8.6671L25.2343 2.92687Z"
            fill={`url(#logo_gradient_two_${uid})`} />
    </svg>
</div>
